/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
// @flow
import * as React from 'react'
import styled from 'styled-components'
import PropTypes from 'prop-types'

import ErrorMessage from '../ErrorMessage'
import Label from './Label'
import colors from '../../styles/colors'
import { css } from 'styled-components'

const TextInput = ({
  type = 'text',
  label,
  errorMessages = {},
  input,
  placeholder,
  disableValidation = false,
  disabled = false,
  readOnly = false,
  maxLength,
  initialValue,
  isRequired = false,
  autocomplete = null,
  roleForErrorMessage = null,
  isPassword = false,
  ...props
}) => {
  const showErrorMessage = (props.meta.error || props.meta.submitError) && props.meta.touched && !disableValidation;
  const ariaDescribedby = showErrorMessage === true ? `error_${input.name}` : null;

  return (
    <Wrapper wrapperWidth={props.width}>
      {label && <Label id={input.name} title={label} />}
      <Input
        id={input.name}
        placeholder={placeholder}
        disabled={disabled}
        readOnly={readOnly}
        type={type}
        maxLength={maxLength}
        {...input}
        value={!input.value ? initialValue : input.value}
        aria-describedby={ariaDescribedby}
        required={isRequired}
        autoComplete={autocomplete}
        isPassword={isPassword}
      />
      {
        showErrorMessage === true &&
        <ErrorMessage
          errorMessages={errorMessages}
          error={props.meta.error || props.meta.submitError}
          id={ariaDescribedby}
          role={roleForErrorMessage}
        />
      }
    </Wrapper>
  )
}

TextInput.Props = {
  label: PropTypes.string,
  onClick: PropTypes.func,
}

const Wrapper = styled.div`
  position: relative;
  margin-bottom: 50px;
  ${( props ) => props.wrapperWidth && css`width: ${props.wrapperWidth}px` };
`

const Input = styled.input`
  width: 100%;
  border: ${(props) =>
    props.disabled ? 'none' : `1px solid ${colors.light_black}`};
  font-size: 14px;
  padding: 10px 15px;
  border-radius: 4px;
  height: 50px;
  box-sizing: border-box;
  &:disabled {
    background: #ebebe4;
  }
  &:read-only {
    background: ${colors.readOnly};
  }
  ${(props) => (props.isPassword ? '-webkit-text-security: disc' : null)};
`

export default TextInput
